import { useMemo } from 'react';
import { isDoctorUser } from '../utilities/doctorPortal';
import { useCrudAccess, usePageAccess } from './usePageAccess';

export function useEntityLinks() {
  const { hasPage, user } = usePageAccess();
  const isDoctor = isDoctorUser(user);
  const clients = useCrudAccess('clients');
  const doctors = useCrudAccess('doctors');
  const orders = useCrudAccess('orders');
  const invoices = useCrudAccess('invoices');
  const users = useCrudAccess('users');
  const expenses = useCrudAccess('expenses');

  return useMemo(
    () => ({
      canOpenClient: !isDoctor && (clients.canList || clients.canView),
      canOpenDoctor: !isDoctor && (doctors.canList || doctors.canView || clients.canList || clients.canView),
      canOpenOrder: orders.canList || orders.canView,
      canOpenInvoice: invoices.canList || invoices.canView,
      canOpenUser: users.canList || users.canView,
      canOpenWallet: !isDoctor && (hasPage('wallets') || hasPage('wallets.view')),
      canOpenExpense: expenses.canList || expenses.canView,
    }),
    [
      isDoctor,
      clients.canList,
      clients.canView,
      doctors.canList,
      doctors.canView,
      orders.canList,
      orders.canView,
      invoices.canList,
      invoices.canView,
      users.canList,
      users.canView,
      expenses.canList,
      expenses.canView,
      hasPage,
    ]
  );
}
